import React from "react";
import styled from "styled-components";
import { MatIcon } from "fiver-react-ui-components";
import VoucherText from "./VoucherText";
import { toast } from "react-toastify";
const StyledWrapper = styled.div`
  flex: 1 1 auto;
  min-width: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;

  @media (min-width: ${props => props.theme.screenWidthXxs}) {
    margin: 0;
  }
`;
const StyledContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  & .description {
    display: none;
  }

  @media (min-width: ${props => props.theme.screenWidthSm}) {
    margin-right: 1.5rem;

    & .description {
      display: block;
    }
  }
`;
const StyledShareButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5rem;
  width: 2.5rem;
`;
const StyledCopyToast = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    font-size: 2rem;
  }
  .text {
    margin: auto 1rem;
  }
`;
const StyledCopyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  & .material-icons {
    font-size: 20px;
  }
`;
const StyledCopyButtonText = styled.span`
  margin-left: 0.25rem;
  font-size: 0.75rem;
`;

const Wrapper = ({
  voucherCode
}) => {
  const currencySymbol = process.env.REACT_APP_CURRENCY_SYMBOL;
  const voucherAmount = process.env.REACT_APP_VOUCHER_PRIZE_AMOUNT;
  const voucherTitle = process.env.REACT_APP_VOUCHER_SHARE_TITLE || `Play this game to earn ${currencySymbol}${voucherAmount}`;

  const copyToClipboard = () => {
    toast.success( /*#__PURE__*/React.createElement(StyledCopyToast, null, /*#__PURE__*/React.createElement(MatIcon, {
      className: "icon"
    }, "content_copy"), /*#__PURE__*/React.createElement("div", {
      className: "text"
    }, "Copied to clipboard")));
  };

  const onCopyClicked = e => {
    e.preventDefault();
    copyToClipboard();
    navigator.clipboard.writeText(voucherCode);
  };

  const onShareClicked = e => {
    e.preventDefault();

    if (navigator.share) {
      navigator.share({
        title: process.env.REACT_APP_VOUCHER_SHARE_TITLE,
        text: `Hi, earn yourself a ${process.env.REACT_APP_CURRENCY_SYMBOL}${process.env.REACT_APP_VOUCHER_PRIZE_AMOUNT} Uber Eats discount code by placing your free picks!`,
        url: process.env.REACT_APP_VOUCHER_SHARE_URL || document.location.href
      }).then(() => {
        console.log("Successfully shared");
      }).catch(error => {
        console.error("Something went wrong sharing the blog", error);
      });
    }
  };

  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(StyledShareButton, {
    onClick: onShareClicked
  }, /*#__PURE__*/React.createElement(MatIcon, null, "ios_share")), /*#__PURE__*/React.createElement(StyledContent, null, /*#__PURE__*/React.createElement(VoucherText, {
    className: "description",
    isLabel: true,
    size: "md",
    textAlign: "center",
    marginBottom: "10px"
  }, "Use voucher code"), /*#__PURE__*/React.createElement(VoucherText, {
    size: "lg",
    isBold: true,
    textAlign: "center",
    marginBottom: "10px"
  }, voucherCode), /*#__PURE__*/React.createElement(StyledCopyButton, {
    onClick: onCopyClicked
  }, /*#__PURE__*/React.createElement(MatIcon, null, "content_copy"), /*#__PURE__*/React.createElement(StyledCopyButtonText, null, "Copy It!"))));
};

export default Wrapper;